import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "./Reveal";
import { DoctolibLogo } from "./DoctolibLogo";
import { SITE } from "@/constants/site";
import useI18n from "@/i18n";

export default function Tarifs() {
    const { t, to } = useI18n();

    return (
        <section id="tarifs" className="grad-down scroll-mt-24 py-16 md:py-24" data-testid="tarifs-section">
            <div className="mx-auto max-w-[1080px] px-5">
                <Reveal>
                    <p className="eyebrow">{t.tarifsSection.eyebrow}</p>
                    <h2 className="text-3xl text-terrat md:text-4xl">{t.tarifsSection.h2}</h2>
                    <hr className="rule-gold mt-4 w-16" />
                    <p className="mt-4 max-w-[52ch] text-lg text-ink2">{t.tarifsSection.lead}</p>
                </Reveal>

                <Reveal delay={0.05}>
                    <div className="mt-10 grid gap-5 sm:grid-cols-2">
                        {t.tarifsData.consultations.map(([label, prix, detail], i) => (
                            <div
                                key={label}
                                className="card card-motif flex items-center justify-between gap-5 p-6"
                                data-testid={`tarif-ligne-${i + 1}`}
                            >
                                <div>
                                    <h3 className="text-lg font-bold text-olivet">{label}</h3>
                                    <p className="mt-1 text-sm text-ink2">{detail}</p>
                                </div>
                                <p className="font-display text-3xl text-terrat">{prix}</p>
                            </div>
                        ))}
                    </div>
                </Reveal>

                <Reveal delay={0.1}>
                    <div className="card card-motif mt-6 p-6" data-testid="tarifs-apercu">
                        <h3 className="text-lg font-bold text-olivet">{t.tarifsSection.apercuTitle}</h3>
                        <hr className="rule-gold mt-3 w-12" />
                        <ul className="mt-2 sm:columns-2 sm:gap-x-10">
                            {t.tarifsSection.apercu.map(([label, prix]) => (
                                <li
                                    key={label}
                                    className="flex items-baseline justify-between gap-4 border-b py-2.5 last:border-0"
                                    style={{ borderColor: "var(--c-line)" }}
                                >
                                    <span>{label}</span>
                                    <span className="whitespace-nowrap font-bold text-terrat">{prix}</span>
                                </li>
                            ))}
                        </ul>
                        <Link
                            to={to("tarifs")}
                            className="link-underline mt-5 inline-flex items-center gap-1.5 text-sm font-bold text-terrat"
                            data-testid="tarifs-detail-link"
                        >
                            {t.tarifsSection.detailLink}
                            <ArrowRight size={14} aria-hidden="true" />
                        </Link>
                    </div>
                </Reveal>

                <Reveal>
                    <div className="card mt-6 flex flex-col items-start justify-between gap-5 p-6 md:flex-row md:items-center">
                        <p className="max-w-[58ch] text-sm text-ink2">{t.tarifsSection.note}</p>
                        <a
                            href={SITE.doctolibUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="tarifs-rdv-button"
                            className="btn btn-primary shrink-0"
                        >
                            {t.common.rdvOn}
                            <DoctolibLogo height={15} color="#FFFFFF" />
                        </a>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
